<p-columnFilter matchMode="equals" showClearButton="false" showMatchModes="false" type="date" [field]="field"
  showMenu="false">
  <ng-template pTemplate="filter">
    <div class="datetime-range-inputs">
      <p-datepicker [formControl]="control" [showTime]="true" [hideOnDateTimeSelect]="false" [hourFormat]="'12'"
        dateFormat="dd/mm/yy" showIcon iconDisplay="input" size="small" placeholder="Inicio" appendTo="body"
        [showOnFocus]="false" (onClose)="onDateTimeClose()" />
      <span>-</span>
      <p-datepicker [formControl]="controlAlter" [showTime]="true" [hideOnDateTimeSelect]="false" [hourFormat]="'12'"
        dateFormat="dd/mm/yy" showIcon iconDisplay="input" size="small" placeholder="Fin" appendTo="body"
        [showOnFocus]="false" (onClose)="onDateTimeClose()" />
    </div>
  </ng-template>
</p-columnFilter>